import { Route, Routes } from 'react-router-dom';
import { PaletteUtils, RoutePaths } from '@shared/utils';
import { SignUpPage, SignUpPersonalPage, SignUpVcfcPage, SuccessPage, SuccessVcfcPage } from '@pages';

export const Public = () => {
  return (
    <Routes>
      {PaletteUtils.isInsigniaPalette && <Route path={RoutePaths.signup.path} element={<SignUpPage />} />}
      {PaletteUtils.isPersonalPalette && <Route path={RoutePaths.signup.path} element={<SignUpPersonalPage />} />}
      {PaletteUtils.isVcfcPalette && <Route path={RoutePaths.signup.path} element={<SignUpVcfcPage />} />}
      {PaletteUtils.isInsigniaPalette && <Route path={RoutePaths.success.path} element={<SuccessPage />} />}
      {PaletteUtils.isVcfcPalette && <Route path={RoutePaths.success.path} element={<SuccessVcfcPage />} />}
    </Routes>
  );
};
